"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listaCodigoInternacionalTelefone = void 0;
exports.listaCodigoInternacionalTelefone = [
    { code: 'BR', country: 'Brasil', dialCode: '55', bandeira: 'BR_4x3' },
    { code: 'AF', country: 'Afeganistão', dialCode: '93', bandeira: 'AF_4x3' },
    { code: 'AL', country: 'Albânia', dialCode: '355', bandeira: 'AL_4x3' },
    { code: 'DZ', country: 'Argélia', dialCode: '213', bandeira: 'DZ_4x3' },
    { code: 'AD', country: 'Andorra', dialCode: '376', bandeira: 'AD_4x3' },
    { code: 'AO', country: 'Angola', dialCode: '244', bandeira: 'AO_4x3' },
    { code: 'AG', country: 'Antígua e Barbuda', dialCode: '1-268', bandeira: 'AG_4x3' },
    { code: 'AR', country: 'Argentina', dialCode: '54', bandeira: 'AR_4x3' },
    { code: 'AM', country: 'Armênia', dialCode: '374', bandeira: 'AM_4x3' },
    { code: 'AU', country: 'Austrália', dialCode: '61', bandeira: 'AU_4x3' },
    { code: 'AT', country: 'Áustria', dialCode: '43', bandeira: 'AT_4x3' },
    { code: 'AZ', country: 'Azerbaijão', dialCode: '994', bandeira: 'AZ_4x3' },
    { code: 'BS', country: 'Bahamas', dialCode: '1-242', bandeira: 'BS_4x3' },
    { code: 'BH', country: 'Bahrein', dialCode: '973', bandeira: 'BH_4x3' },
    { code: 'BD', country: 'Bangladesh', dialCode: '880', bandeira: 'BD_4x3' },
    { code: 'BB', country: 'Barbados', dialCode: '1-246', bandeira: 'BB_4x3' },
    { code: 'BY', country: 'Bielorrússia', dialCode: '375', bandeira: 'BY_4x3' },
    { code: 'BE', country: 'Bélgica', dialCode: '32', bandeira: 'BE_4x3' },
    { code: 'BZ', country: 'Belize', dialCode: '501', bandeira: 'BZ_4x3' },
    { code: 'BJ', country: 'Benin', dialCode: '229', bandeira: 'BJ_4x3' },
    { code: 'BT', country: 'Butão', dialCode: '975', bandeira: 'BT_4x3' },
    { code: 'BO', country: 'Bolívia', dialCode: '591', bandeira: 'BO_4x3' },
    { code: 'BA', country: 'Bósnia e Herzegovina', dialCode: '387', bandeira: 'BA_4x3' },
    { code: 'BW', country: 'Botswana', dialCode: '267', bandeira: 'BW_4x3' },
    { code: 'BN', country: 'Brunei', dialCode: '673', bandeira: 'BN_4x3' },
    { code: 'BG', country: 'Bulgária', dialCode: '359', bandeira: 'BG_4x3' },
    { code: 'BF', country: 'Burkina Faso', dialCode: '226', bandeira: 'BF_4x3' },
    { code: 'BI', country: 'Burundi', dialCode: '257', bandeira: 'BI_4x3' },
    { code: 'KH', country: 'Camboja', dialCode: '855', bandeira: 'KH_4x3' },
    { code: 'CM', country: 'Camarões', dialCode: '237', bandeira: 'CM_4x3' },
    { code: 'CA', country: 'Canadá', dialCode: '1', bandeira: 'CA_4x3' },
    { code: 'CV', country: 'Cabo Verde', dialCode: '238', bandeira: 'CV_4x3' },
    { code: 'CF', country: 'República Centro-Africana', dialCode: '236', bandeira: 'CF_4x3' },
    { code: 'TD', country: 'Chade', dialCode: '235', bandeira: 'TD_4x3' },
    { code: 'CL', country: 'Chile', dialCode: '56', bandeira: 'CL_4x3' },
    { code: 'CN', country: 'China', dialCode: '86', bandeira: 'CN_4x3' },
    { code: 'CO', country: 'Colômbia', dialCode: '57', bandeira: 'CO_4x3' },
    { code: 'KM', country: 'Comores', dialCode: '269', bandeira: 'KM_4x3' },
    { code: 'CG', country: 'Congo', dialCode: '242', bandeira: 'CG_4x3' },
    { code: 'CR', country: 'Costa Rica', dialCode: '506', bandeira: 'CR_4x3' },
    { code: 'HR', country: 'Croácia', dialCode: '385', bandeira: 'HR_4x3' },
    { code: 'CU', country: 'Cuba', dialCode: '53', bandeira: 'CU_4x3' },
    { code: 'CY', country: 'Chipre', dialCode: '357', bandeira: 'CY_4x3' },
    { code: 'CZ', country: 'República Tcheca', dialCode: '420', bandeira: 'CZ_4x3' },
    { code: 'DK', country: 'Dinamarca', dialCode: '45', bandeira: 'DK_4x3' },
    { code: 'DJ', country: 'Djibouti', dialCode: '253', bandeira: 'DJ_4x3' },
    { code: 'DM', country: 'Dominica', dialCode: '1-767', bandeira: 'DM_4x3' },
    { code: 'DO', country: 'República Dominicana', dialCode: '1-809', bandeira: 'DO_4x3' },
    { code: 'US', country: 'Estados Unidos', dialCode: '1', bandeira: 'US_4x3' },
    { code: 'EC', country: 'Equador', dialCode: '593', bandeira: 'EC_4x3' },
    { code: 'EG', country: 'Egito', dialCode: '20', bandeira: 'EG_4x3' },
    { code: 'SV', country: 'El Salvador', dialCode: '503', bandeira: 'SV_4x3' },
    { code: 'GQ', country: 'Guiné Equatorial', dialCode: '240', bandeira: 'GQ_4x3' },
    { code: 'ER', country: 'Eritreia', dialCode: '291', bandeira: 'ER_4x3' },
    { code: 'EE', country: 'Estônia', dialCode: '372', bandeira: 'EE_4x3' },
    { code: 'ET', country: 'Etiópia', dialCode: '251', bandeira: 'ET_4x3' },
    { code: 'FJ', country: 'Fiji', dialCode: '679', bandeira: 'FJ_4x3' },
    { code: 'FI', country: 'Finlândia', dialCode: '358', bandeira: 'FI_4x3' },
    { code: 'FR', country: 'França', dialCode: '33', bandeira: 'FR_4x3' },
    { code: 'GA', country: 'Gabão', dialCode: '241', bandeira: 'GA_4x3' },
    { code: 'GM', country: 'Gâmbia', dialCode: '220', bandeira: 'GM_4x3' },
    { code: 'GE', country: 'Geórgia', dialCode: '995', bandeira: 'GE_4x3' },
    { code: 'DE', country: 'Alemanha', dialCode: '49', bandeira: 'DE_4x3' },
    { code: 'GH', country: 'Gana', dialCode: '233', bandeira: 'GH_4x3' },
    { code: 'GR', country: 'Grécia', dialCode: '30', bandeira: 'GR_4x3' },
    { code: 'GD', country: 'Granada', dialCode: '1-473', bandeira: 'GD_4x3' },
    { code: 'GT', country: 'Guatemala', dialCode: '502', bandeira: 'GT_4x3' },
    { code: 'GN', country: 'Guiné', dialCode: '224', bandeira: 'GN_4x3' },
    { code: 'GW', country: 'Guiné-Bissau', dialCode: '245', bandeira: 'GW_4x3' },
    { code: 'GY', country: 'Guiana', dialCode: '592', bandeira: 'GY_4x3' },
    { code: 'HT', country: 'Haiti', dialCode: '509', bandeira: 'HT_4x3' },
    { code: 'HN', country: 'Honduras', dialCode: '504', bandeira: 'HN_4x3' },
    { code: 'HU', country: 'Hungria', dialCode: '36', bandeira: 'HU_4x3' },
    { code: 'IS', country: 'Islândia', dialCode: '354', bandeira: 'IS_4x3' },
    { code: 'IN', country: 'Índia', dialCode: '91', bandeira: 'IN_4x3' },
    { code: 'ID', country: 'Indonésia', dialCode: '62', bandeira: 'ID_4x3' },
    { code: 'IR', country: 'Irã', dialCode: '98', bandeira: 'IR_4x3' },
    { code: 'IQ', country: 'Iraque', dialCode: '964', bandeira: 'IQ_4x3' },
    { code: 'IE', country: 'Irlanda', dialCode: '353', bandeira: 'IE_4x3' },
    { code: 'IL', country: 'Israel', dialCode: '972', bandeira: 'IL_4x3' },
    { code: 'IT', country: 'Itália', dialCode: '39', bandeira: 'IT_4x3' },
    { code: 'JM', country: 'Jamaica', dialCode: '1-876', bandeira: 'JM_4x3' },
    { code: 'JP', country: 'Japão', dialCode: '81', bandeira: 'JP_4x3' },
    { code: 'JO', country: 'Jordânia', dialCode: '962', bandeira: 'JO_4x3' },
    { code: 'KZ', country: 'Cazaquistão', dialCode: '7', bandeira: 'KZ_4x3' },
    { code: 'KE', country: 'Quênia', dialCode: '254', bandeira: 'KE_4x3' },
    { code: 'KI', country: 'Kiribati', dialCode: '686', bandeira: 'KI_4x3' },
    { code: 'KP', country: 'Coreia do Norte', dialCode: '850', bandeira: 'KP_4x3' },
    { code: 'KR', country: 'Coreia do Sul', dialCode: '82', bandeira: 'KR_4x3' },
    { code: 'KW', country: 'Kuwait', dialCode: '965', bandeira: 'KW_4x3' },
    { code: 'KG', country: 'Quirguistão', dialCode: '996', bandeira: 'KG_4x3' },
    { code: 'LA', country: 'Laos', dialCode: '856', bandeira: 'LA_4x3' },
    { code: 'LV', country: 'Letônia', dialCode: '371', bandeira: 'LV_4x3' },
    { code: 'LB', country: 'Líbano', dialCode: '961', bandeira: 'LB_4x3' },
    { code: 'LS', country: 'Lesoto', dialCode: '266', bandeira: 'LS_4x3' },
    { code: 'LR', country: 'Libéria', dialCode: '231', bandeira: 'LR_4x3' },
    { code: 'LY', country: 'Líbia', dialCode: '218', bandeira: 'LY_4x3' },
    { code: 'LI', country: 'Liechtenstein', dialCode: '423', bandeira: 'LI_4x3' },
    { code: 'LT', country: 'Lituânia', dialCode: '370', bandeira: 'LT_4x3' },
    { code: 'LU', country: 'Luxemburgo', dialCode: '352', bandeira: 'LU_4x3' },
    { code: 'MG', country: 'Madagáscar', dialCode: '261', bandeira: 'MG_4x3' },
    { code: 'MW', country: 'Malawi', dialCode: '265', bandeira: 'MW_4x3' },
    { code: 'MY', country: 'Malásia', dialCode: '60', bandeira: 'MY_4x3' },
    { code: 'MV', country: 'Maldivas', dialCode: '960', bandeira: 'MV_4x3' },
    { code: 'ML', country: 'Mali', dialCode: '223', bandeira: 'ML_4x3' },
    { code: 'MT', country: 'Malta', dialCode: '356', bandeira: 'MT_4x3' },
    { code: 'MH', country: 'Ilhas Marshall', dialCode: '692', bandeira: 'MH_4x3' },
    { code: 'MR', country: 'Mauritânia', dialCode: '222', bandeira: 'MR_4x3' },
    { code: 'MU', country: 'Maurício', dialCode: '230', bandeira: 'MU_4x3' },
    { code: 'MX', country: 'México', dialCode: '52', bandeira: 'MX_4x3' },
    { code: 'FM', country: 'Micronésia', dialCode: '691', bandeira: 'FM_4x3' },
    { code: 'MD', country: 'Moldávia', dialCode: '373', bandeira: 'MD_4x3' },
    { code: 'MC', country: 'Mônaco', dialCode: '377', bandeira: 'MC_4x3' },
    { code: 'MN', country: 'Mongólia', dialCode: '976', bandeira: 'MN_4x3' },
    { code: 'ME', country: 'Montenegro', dialCode: '382', bandeira: 'ME_4x3' },
    { code: 'MA', country: 'Marrocos', dialCode: '212', bandeira: 'MA_4x3' },
    { code: 'MZ', country: 'Moçambique', dialCode: '258', bandeira: 'MZ_4x3' },
    { code: 'MM', country: 'Mianmar', dialCode: '95', bandeira: 'MM_4x3' },
    { code: 'NA', country: 'Namíbia', dialCode: '264', bandeira: 'NA_4x3' },
    { code: 'NR', country: 'Nauru', dialCode: '674', bandeira: 'NR_4x3' },
    { code: 'NP', country: 'Nepal', dialCode: '977', bandeira: 'NP_4x3' },
    { code: 'NL', country: 'Países Baixos', dialCode: '31', bandeira: 'NL_4x3' },
    { code: 'NZ', country: 'Nova Zelândia', dialCode: '64', bandeira: 'NZ_4x3' },
    { code: 'NI', country: 'Nicarágua', dialCode: '505', bandeira: 'NI_4x3' },
    { code: 'NE', country: 'Níger', dialCode: '227', bandeira: 'NE_4x3' },
    { code: 'NG', country: 'Nigéria', dialCode: '234', bandeira: 'NG_4x3' },
    { code: 'NO', country: 'Noruega', dialCode: '47', bandeira: 'NO_4x3' },
    { code: 'OM', country: 'Omã', dialCode: '968', bandeira: 'OM_4x3' },
    { code: 'PK', country: 'Paquistão', dialCode: '92', bandeira: 'PK_4x3' },
    { code: 'PW', country: 'Palau', dialCode: '680', bandeira: 'PW_4x3' },
    { code: 'PS', country: 'Palestina', dialCode: '970', bandeira: 'PS_4x3' },
    { code: 'PA', country: 'Panamá', dialCode: '507', bandeira: 'PA_4x3' },
    { code: 'PG', country: 'Papua Nova Guiné', dialCode: '675', bandeira: 'PG_4x3' },
    { code: 'PY', country: 'Paraguai', dialCode: '595', bandeira: 'PY_4x3' },
    { code: 'PE', country: 'Peru', dialCode: '51', bandeira: 'PE_4x3' },
    { code: 'PH', country: 'Filipinas', dialCode: '63', bandeira: 'PH_4x3' },
    { code: 'PL', country: 'Polônia', dialCode: '48', bandeira: 'PL_4x3' },
    { code: 'PT', country: 'Portugal', dialCode: '351', bandeira: 'PT_4x3' },
    { code: 'QA', country: 'Catar', dialCode: '974', bandeira: 'QA_4x3' },
    { code: 'GB', country: 'Reino Unido', dialCode: '44', bandeira: 'GB_4x3' },
    { code: 'RO', country: 'Romênia', dialCode: '40', bandeira: 'RO_4x3' },
    { code: 'RU', country: 'Rússia', dialCode: '7', bandeira: 'RU_4x3' },
    { code: 'RW', country: 'Ruanda', dialCode: '250', bandeira: 'RW_4x3' },
    { code: 'KN', country: 'São Cristóvão e Neves', dialCode: '1-869', bandeira: 'KN_4x3' },
    { code: 'LC', country: 'Santa Lúcia', dialCode: '1-758', bandeira: 'LC_4x3' },
    { code: 'VC', country: 'São Vicente e Granadinas', dialCode: '1-784', bandeira: 'VC_4x3' },
    { code: 'WS', country: 'Samoa', dialCode: '685', bandeira: 'WS_4x3' },
    { code: 'SM', country: 'San Marino', dialCode: '378', bandeira: 'SM_4x3' },
    { code: 'ST', country: 'São Tomé e Príncipe', dialCode: '239', bandeira: 'ST_4x3' },
    { code: 'SA', country: 'Arábia Saudita', dialCode: '966', bandeira: 'SA_4x3' },
    { code: 'SN', country: 'Senegal', dialCode: '221', bandeira: 'SN_4x3' },
    { code: 'RS', country: 'Sérvia', dialCode: '381', bandeira: 'RS_4x3' },
    { code: 'SC', country: 'Seychelles', dialCode: '248', bandeira: 'SC_4x3' },
    { code: 'SL', country: 'Serra Leoa', dialCode: '232', bandeira: 'SL_4x3' },
    { code: 'SG', country: 'Singapura', dialCode: '65', bandeira: 'SG_4x3' },
    { code: 'SK', country: 'Eslováquia', dialCode: '421', bandeira: 'SK_4x3' },
    { code: 'SI', country: 'Eslovênia', dialCode: '386', bandeira: 'SI_4x3' },
    { code: 'SB', country: 'Ilhas Salomão', dialCode: '677', bandeira: 'SB_4x3' },
    { code: 'SO', country: 'Somália', dialCode: '252', bandeira: 'SO_4x3' },
    { code: 'ZA', country: 'África do Sul', dialCode: '27', bandeira: 'ZA_4x3' },
    { code: 'SS', country: 'Sudão do Sul', dialCode: '211', bandeira: 'SS_4x3' },
    { code: 'ES', country: 'Espanha', dialCode: '34', bandeira: 'ES_4x3' },
    { code: 'LK', country: 'Sri Lanka', dialCode: '94', bandeira: 'LK_4x3' },
    { code: 'SD', country: 'Sudão', dialCode: '249', bandeira: 'SD_4x3' },
    { code: 'SR', country: 'Suriname', dialCode: '597', bandeira: 'SR_4x3' },
    { code: 'SZ', country: 'Eswatini', dialCode: '268', bandeira: 'SZ_4x3' },
    { code: 'SE', country: 'Suécia', dialCode: '46', bandeira: 'SE_4x3' },
    { code: 'CH', country: 'Suíça', dialCode: '41', bandeira: 'CH_4x3' },
    { code: 'SY', country: 'Síria', dialCode: '963', bandeira: 'SY_4x3' },
    { code: 'TW', country: 'Taiwan', dialCode: '886', bandeira: 'TW_4x3' },
    { code: 'TJ', country: 'Tajiquistão', dialCode: '992', bandeira: 'TJ_4x3' },
    { code: 'TZ', country: 'Tanzânia', dialCode: '255', bandeira: 'TZ_4x3' },
    { code: 'TH', country: 'Tailândia', dialCode: '66', bandeira: 'TH_4x3' },
    { code: 'TL', country: 'Timor-Leste', dialCode: '670', bandeira: 'TL_4x3' },
    { code: 'TG', country: 'Togo', dialCode: '228', bandeira: 'TG_4x3' },
    { code: 'TO', country: 'Tonga', dialCode: '676', bandeira: 'TO_4x3' },
    { code: 'TT', country: 'Trinidad e Tobago', dialCode: '1-868', bandeira: 'TT_4x3' },
    { code: 'TN', country: 'Tunísia', dialCode: '216', bandeira: 'TN_4x3' },
    { code: 'TR', country: 'Turquia', dialCode: '90', bandeira: 'TR_4x3' },
    { code: 'TM', country: 'Turcomenistão', dialCode: '993', bandeira: 'TM_4x3' },
    { code: 'TV', country: 'Tuvalu', dialCode: '688', bandeira: 'TV_4x3' },
    { code: 'UG', country: 'Uganda', dialCode: '256', bandeira: 'UG_4x3' },
    { code: 'UA', country: 'Ucrânia', dialCode: '380', bandeira: 'UA_4x3' },
    { code: 'AE', country: 'Emirados Árabes Unidos', dialCode: '971', bandeira: 'AE_4x3' },
    { code: 'UY', country: 'Uruguai', dialCode: '598', bandeira: 'UY_4x3' },
    { code: 'UZ', country: 'Uzbequistão', dialCode: '998', bandeira: 'UZ_4x3' },
    { code: 'VU', country: 'Vanuatu', dialCode: '678', bandeira: 'VU_4x3' },
    { code: 'VA', country: 'Vaticano', dialCode: '379', bandeira: 'VA_4x3' },
    { code: 'VE', country: 'Venezuela', dialCode: '58', bandeira: 'VE_4x3' },
    { code: 'VN', country: 'Vietnã', dialCode: '84', bandeira: 'VN_4x3' },
    { code: 'YE', country: 'Iêmen', dialCode: '967', bandeira: 'YE_4x3' },
    { code: 'ZM', country: 'Zâmbia', dialCode: '260', bandeira: 'ZM_4x3' },
    { code: 'ZW', country: 'Zimbábue', dialCode: '263', bandeira: 'ZW_4x3' },
];
